import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import Dashboard from "./pages/Dashboard";
import Account from "./pages/Account";
import NotFound from "./pages/NotFound";
import MainLayout from "./layouts/MainLayout";
import AuthLayout from "./layouts/AuthLayout";
import Login from "./pages/Login";
import "./App.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import Register from "./pages/Register";
import { UserProvider } from "./context/UserContext";
import BankTransfer from "./pages/BankTransfer";
import Logout from "./pages/Logout";
import Product from "./pages/Product";
import { AdminDashboard } from "./pages/admin/AdminDashboard";
import AdminLayout from "./layouts/AdminLayout";
import Unauthorized from "./pages/Unauthorized";
import { AdminPayment } from "./pages/admin/AdminPayment";
import { AdminProduct } from "./pages/admin/AdminProduct";
import { AdminAddProduct } from "./pages/admin/AdminAddProduct";
import { AdminProductDetail } from "./pages/admin/AdminProductDetail";
import { AdminEditProduct } from "./pages/admin/AdminEditProduct";
import Checkout from "./pages/Checkout";
import DepositHistory from "./pages/DepositHistory";
import TransactionHistory from "./pages/TransactionHistory";
import OrderSuccess from "./pages/OrderSuccess";
import { AdminOrder } from "./pages/admin/AdminOrder";
import { AdminOrderDetail } from "./pages/admin/AdminOrderDetail";
import Order from "./pages/Order";
import { OrderDetail } from "./pages/OrderDetail";
import { AdminUser } from "./pages/admin/AdminUser";
import { AdminUserDetail } from "./pages/admin/AdminUserDetail";
import { AdminEditUser } from "./pages/admin/AdminEditUser";
import Banned from "./pages/Banned";
import { AdminDiscount } from "./pages/admin/AdminDiscount";
import AdminDiscountDetail from "./pages/admin/AdminDiscountDetail";
import AdminReviews from "./pages/admin/AdminReviews";
import Rank from "./pages/Rank";
import { ProductReviews } from "./pages/ProductReviews";
import { ChangePassword } from "./pages/ChangePassword";
import { AdminEmail } from "./pages/admin/AdminEmail";
import { AdminEmailDetail } from "./pages/admin/AdminEmailDetail";
import { Code } from "./pages/Code";
import { ChangeInformation } from "./pages/ChangeInformation";
import { ForgotPassword } from "./pages/ForgotPassword";
import { ResetPassword } from "./pages/ResetPassword";
import { AdminEmployee } from "./pages/admin/AdminEmployee";
import { AdminSettings } from "./pages/admin/AdminSettings";
import { Cart } from "./pages/Cart";
import { Search } from "./pages/Search";
import BankTransferDetail from "./pages/BankTransferDetail";
import { Payment } from "./pages/Payment";
import { CardTransfer } from "./pages/CardTransfer";
import { SettingsProvider } from "./context/SettingsContext";
import { GameAccountCategory } from "./pages/GameAccountCategory";
import { TopUpCategory } from "./pages/TopupPackage";
import { UtilityAccountCategory } from "./pages/UtilityAccountCategory";
import TermOfServicePage from "./pages/TermOfService";
import PrivacyPolicyPage from "./pages/PrivacyPolicy";
import AboutUs from "./pages/AboutUs";
import { GiftCardCategory } from "./pages/GiftCard";

function App() {
  return (
    <SettingsProvider>
      <UserProvider>
        <AuthProvider>
          <Router>
            <Routes>
              {/* Public Routes */}
              <Route element={<MainLayout />}>
                <Route path="/" element={<Dashboard />} />
                <Route path="/search" element={<Search />} />
                <Route path="/product/:product_slug" element={<Product />} />
                <Route path="/product/reviews/:product_slug" element={<ProductReviews />} />
                <Route path="/category/game-account" element={<GameAccountCategory />} />
                <Route path="/category/top-up" element={<TopUpCategory />} />
                <Route path="/category/utility-account" element={<UtilityAccountCategory />} />
                <Route path="/category/gift-card" element={<GiftCardCategory/>} />
                <Route path="/term-of-service" element={<TermOfServicePage />} />
                <Route path="/privacy-policy" element={<PrivacyPolicyPage/>} />
                <Route path="*" element={<NotFound />} />
                <Route path="/unauthorized" element={<Unauthorized />} />
                <Route path="/banned" element={<Banned />} />
                <Route path="/about-us" element={<AboutUs/>} />
              </Route>

              {/* Auth Routes */}
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />

              {/* Client Routes */}
              <Route element={<AuthLayout />}>
                <Route path="/logout" element={<Logout />} />
                <Route element={<MainLayout />}>
                  <Route path="/account" element={<Account />} />
                  <Route path="/account/change-password" element={<ChangePassword />} />
                  <Route path="/account/change-information" element={<ChangeInformation />} />
                  <Route path="/payment" element={<Payment />} />
                  <Route path="/payment/bank-transfer" element={<BankTransfer />} />
                  <Route path="/payment/bank-transfer/:transactionId" element={<BankTransferDetail />} />
                  <Route path="/payment/card-transfer" element={<CardTransfer />} />
                  <Route path="/deposit-history" element={<DepositHistory />} />
                  <Route
                    path="/transaction-history"
                    element={<TransactionHistory />}
                  />
                  <Route path="/checkout" element={<Checkout />} />
                  <Route path="/order-success" element={<OrderSuccess />} />
                  <Route path="/order" element={<Order />} />
                  <Route path="/order/:orderId" element={<OrderDetail />} />
                  <Route path="/rank" element={<Rank />} />
                  <Route path="/konami-code" element={<Code />} />
                  <Route path="/cart" element={<Cart />} />
                </Route>
              </Route>

              {/* Admin Routes */}
              <Route element={<AdminLayout />}>
                <Route
                  path="/super-admin/dashboard"
                  element={<AdminDashboard />}
                />

                <Route path="/super-admin/payment" element={<AdminPayment />} />

                <Route path="/super-admin/products" element={<AdminProduct />} />
                <Route
                  path="/super-admin/products/add-product"
                  element={<AdminAddProduct />}
                />
                <Route
                  path="/super-admin/products/view/:productId"
                  element={<AdminProductDetail />}
                />
                <Route
                  path="/super-admin/products/edit/:productId"
                  element={<AdminEditProduct />}
                />

                <Route path="/super-admin/orders" element={<AdminOrder />} />
                <Route
                  path="/super-admin/orders/view/:orderId"
                  element={<AdminOrderDetail />}
                />

                <Route path="/super-admin/users" element={<AdminUser />} />
                <Route
                  path="/super-admin/users/view/:userId"
                  element={<AdminUserDetail />}
                />
                <Route
                  path="/super-admin/users/edit/:userId"
                  element={<AdminEditUser />}
                />

                <Route path="/super-admin/discounts" element={<AdminDiscount />} />
                <Route path="/super-admin/discounts/view/:discountId" element={<AdminDiscountDetail />} />

                <Route path="/super-admin/reviews" element={<AdminReviews />} />

                <Route path="/super-admin/emails" element={<AdminEmail />} />
                <Route path="/super-admin/emails/view/:alias" element={<AdminEmailDetail />} />

                <Route path="/super-admin/employees" element={<AdminEmployee />} />

                <Route path="/super-admin/settings" element={<AdminSettings />} />
              </Route>
            </Routes>
          </Router>
        </AuthProvider>
      </UserProvider>
    </SettingsProvider>
  );
}

export default App;
